<div
  class="overflow-visible"
  [ngClass]="flatShell
    ? 'bg-transparent'
    : mobileFlatShell && mobileCardView
    ? 'bg-transparent md:rounded-2xl md:border md:border-gray-200 md:bg-white md:dark:border-gray-800 md:dark:bg-white/[0.03]'
    : 'rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]'">
  @if (title) {
    <div
      [ngClass]="flatShell
        ? 'px-0 pb-3 pt-0'
        : mobileFlatShell && mobileCardView
        ? 'px-0 pb-3 pt-0 md:px-6 md:py-5'
        : 'px-5 py-4 sm:px-6 sm:py-5'">
      <h3 class="text-base font-medium text-gray-800 dark:text-white/90">
        {{ title }}
      </h3>
    </div>
  }
  <div
    class="relative"
    [ngClass]="flatShell
      ? 'p-0'
      : mobileFlatShell && mobileCardView
      ? 'p-0 md:border-t md:border-gray-100 md:p-6 md:dark:border-gray-800'
      : 'border-t border-gray-100 p-5 dark:border-gray-800 sm:p-6'">
    <div
      class="overflow-visible"
      [ngClass]="[
        flatShell
          ? 'bg-transparent pt-0'
          : mobileFlatShell && mobileCardView
          ? 'bg-transparent pt-0 md:rounded-xl md:border md:border-gray-200 md:bg-white md:pt-4 md:dark:border-gray-800 md:dark:bg-white/[0.03]'
          : 'rounded-xl border border-gray-200 bg-white pt-4 dark:border-gray-800 dark:bg-white/[0.03]',
        loading && !dataPage ? 'opacity-50 pointer-events-none' : ''
      ]">
      @if (loading) {
        <div class="absolute inset-0 bg-white/80 dark:bg-gray-900/80 z-50 flex items-center justify-center rounded-xl">
          <div class="flex flex-col items-center gap-2">
            <lucide-icon [name]="LoaderIcon" size="48" class="text-primary-500 animate-spin"></lucide-icon>
            <p class="text-sm font-medium text-gray-600 dark:text-gray-400">Loading...</p>
          </div>
        </div>
      }


      <div
        class="mb-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between"
        [ngClass]="flatShell ? 'px-0' : mobileFlatShell && mobileCardView ? 'px-0 md:px-4' : 'px-4'">
        <ng-content select="[header]"></ng-content>
      </div>


      @if (dataPage && dataPage.data && dataPage.data.length > 0) {
        @if (mobileCardView) {
          <div
            class="space-y-3 pb-4 md:hidden"
            [ngClass]="flatShell || mobileFlatShell ? 'px-0' : 'px-4'">
            @for (item of dataPage.data; track item.id) {
              <article
                (click)="isRowInteractive() ? onRowClick(item) : null"
                class="rounded-2xl border border-gray-200 bg-white shadow-theme-xs transition-colors dark:border-gray-800 dark:bg-gray-900/40"
                [ngClass]="[
                  mobileCompact ? 'px-3 py-2' : 'p-4',
                  isRowInteractive() ? 'cursor-pointer hover:border-brand-200 hover:bg-brand-50/30 dark:hover:border-brand-800 dark:hover:bg-brand-950/10' : '',
                  highlightSelectedRow && selectedRowId === item.id ? selectedRowClass : ''
                ]">
                @if (mobileCompact) {
                  <div class="flex items-center gap-3">
                    @if (mobilePrimaryColumn) {
                      <div class="min-w-0 flex-1 truncate text-sm font-semibold text-gray-900 dark:text-white">
                        @if (mobilePrimaryColumn.component) {
                          <ng-container *ngComponentOutlet="mobilePrimaryColumn.component; inputs: mobileComponentInputs(mobilePrimaryColumn, item)"></ng-container>
                        } @else {
                          {{ getValue(item, mobilePrimaryColumn) }}
                        }
                      </div>
                    }
                    @if (mobileSecondaryColumns.length > 0) {
                      <div class="flex shrink-0 items-center gap-2 text-xs text-gray-600 dark:text-gray-400">
                        @for (column of mobileSecondaryColumns; track column) {
                          <span>{{ getValue(item, column) }}</span>
                        }
                      </div>
                    }
                    @if (this.rowActions.length > 0) {
                      <div class="flex shrink-0 items-center gap-1.5">
                        @for (action of rowActions; track action) {
                          @if (!action.condition || action.condition(item)) {
                            @if (action.callback) {
                              <button
                                (click)="$event.stopPropagation(); action.callback(item)"
                                [ngClass]="action.classes ?? 'text-gray-500 hover:text-success-500 dark:text-gray-400 dark:hover:text-success-500'"
                                [disabled]="action.disabled ? action.disabled(item) : false"
                                [title]="action.title ? action.title(item) : ''">
                                <lucide-icon [size]="18" [name]="action.icon"></lucide-icon>
                              </button>
                            } @else if (action.routerLink) {
                              <button
                                (click)="$event.stopPropagation()"
                                [routerLink]="action.routerLink(item)"
                                [ngClass]="action.classes ?? 'text-gray-500 hover:text-success-500 dark:text-gray-400 dark:hover:text-success-500'"
                                [disabled]="action.disabled ? action.disabled(item) : false"
                                [title]="action.title ? action.title(item) : ''">
                                <lucide-icon [size]="18" [name]="action.icon"></lucide-icon>
                              </button>
                            }
                          }
                        }
                      </div>
                    }
                  </div>
                } @else {
                @if (mobilePrimaryColumn) {
                  <div class="min-w-0">
                    <p class="mb-1 text-[11px] font-semibold uppercase tracking-[0.12em] text-gray-400 dark:text-gray-500">
                      {{ mobilePrimaryColumn.header }}
                    </p>
                    <div class="min-w-0 text-sm font-semibold text-gray-900 dark:text-white">
                      @if (mobilePrimaryColumn.component) {
                        <ng-container *ngComponentOutlet="mobilePrimaryColumn.component; inputs: mobileComponentInputs(mobilePrimaryColumn, item)"></ng-container>
                      } @else {
                        @if (mobilePrimaryColumn.type === 'badge' && mobilePrimaryColumn.getColor) {
                          <app-badge [text]="getValue(item, mobilePrimaryColumn)" [color]="mobilePrimaryColumn.getColor(item)"></app-badge>
                        } @else {
                          @if (mobilePrimaryColumn.type === 'boolean') {
                            <app-badge [text]="getValue(item, mobilePrimaryColumn) ? 'Yes' : 'No'" [color]="getValue(item, mobilePrimaryColumn) ? 'success' : 'error'"></app-badge>
                          } @else {
                            @if (mobilePrimaryColumn.routerLinkTemplate) {
                              <a
                                [routerLink]="generateRouterLink(mobilePrimaryColumn.routerLinkTemplate, item)"
                                class="text-brand-600 hover:underline dark:text-brand-400">
                                {{ getValue(item, mobilePrimaryColumn) }}
                              </a>
                            } @else {
                              @if (mobilePrimaryColumn.clickHandler) {
                                <button
                                  (click)="$event.stopPropagation(); mobilePrimaryColumn.clickHandler(item)"
                                  class="inline-flex items-center gap-1.5 text-left text-sm font-semibold text-brand-600 underline dark:text-brand-400">
                                  {{ getValue(item, mobilePrimaryColumn) }}
                                  @if (mobilePrimaryColumn.icon && mobilePrimaryColumn.icon(item)) {
                                    <lucide-icon [size]="16" [name]="$any(mobilePrimaryColumn.icon(item))"></lucide-icon>
                                  }
                                </button>
                              } @else {
                                @if (mobilePrimaryColumn.getColor) {
                                  <span [ngClass]="'text-' + mobilePrimaryColumn.getColor(item) + '-600 dark:text-' + mobilePrimaryColumn.getColor(item) + '-400'">
                                    {{ getValue(item, mobilePrimaryColumn) }}
                                  </span>
                                } @else {
                                  {{ getValue(item, mobilePrimaryColumn) }}
                                }
                              }
                            }
                          }
                        }
                      }
                    </div>
                  </div>
                }

                @if (mobileSecondaryColumns.length > 0) {
                  <dl class="mt-4 space-y-3 border-t border-gray-100 pt-4 dark:border-gray-800">
                    @for (column of mobileSecondaryColumns; track column) {
                      <div class="flex items-start justify-between gap-4">
                        <dt class="max-w-[45%] text-[11px] font-semibold uppercase tracking-[0.08em] text-gray-500 dark:text-gray-400">
                          {{ column.header }}
                        </dt>
                        <dd class="min-w-0 flex-1 text-right text-sm text-gray-700 dark:text-gray-300">
                          <div class="inline-flex max-w-full flex-col items-end text-right">
                            @if (column.component) {
                              <ng-container *ngComponentOutlet="column.component; inputs: mobileComponentInputs(column, item)"></ng-container>
                            } @else {
                              @if (column.type === 'badge' && column.getColor) {
                                <app-badge [text]="getValue(item, column)" [color]="column.getColor(item)"></app-badge>
                              } @else {
                                @if (column.type === 'boolean') {
                                  <app-badge [text]="getValue(item, column) ? 'Yes' : 'No'" [color]="getValue(item, column) ? 'success' : 'error'"></app-badge>
                                } @else {
                                  @if (column.routerLinkTemplate) {
                                    <a
                                      [routerLink]="generateRouterLink(column.routerLinkTemplate, item)"
                                      class="text-brand-600 hover:underline dark:text-brand-400">
                                      {{ getValue(item, column) }}
                                    </a>
                                  } @else {
                                    @if (column.clickHandler) {
                                      <button
                                        (click)="$event.stopPropagation(); column.clickHandler(item)"
                                        class="inline-flex items-center gap-1.5 text-right text-sm font-normal text-brand-600 underline dark:text-brand-400">
                                        {{ getValue(item, column) }}
                                        @if (column.icon && column.icon(item)) {
                                          <lucide-icon [size]="16" [name]="$any(column.icon(item))"></lucide-icon>
                                        }
                                      </button>
                                    } @else {
                                      @if (column.getColor) {
                                        <span [ngClass]="'text-' + column.getColor(item) + '-600 dark:text-' + column.getColor(item) + '-400'">
                                          {{ getValue(item, column) }}
                                        </span>
                                      } @else {
                                        {{ getValue(item, column) }}
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          </div>
                        </dd>
                      </div>
                    }
                  </dl>
                }

                @if (this.rowActions.length > 0) {
                  <div class="mt-4 flex justify-end gap-2 border-t border-gray-100 pt-4 dark:border-gray-800">
                    @for (action of rowActions; track action) {
                      @if (!action.condition || action.condition(item)) {
                        @if (action.callback) {
                          <button
                            (click)="$event.stopPropagation(); action.callback(item)"
                            [ngClass]="action.classes ?? 'text-gray-500 hover:text-success-500 dark:text-gray-400 dark:hover:text-success-500'"
                            [disabled]="action.disabled ? action.disabled(item) : false"
                            [title]="action.title ? action.title(item) : ''">
                            <lucide-icon [size]="20" [name]="action.icon"></lucide-icon>
                          </button>
                        } @else if (action.routerLink) {
                          <button
                            (click)="$event.stopPropagation()"
                            [routerLink]="action.routerLink(item)"
                            [ngClass]="action.classes ?? 'text-gray-500 hover:text-success-500 dark:text-gray-400 dark:hover:text-success-500'"
                            [disabled]="action.disabled ? action.disabled(item) : false"
                            [title]="action.title ? action.title(item) : ''">
                            <lucide-icon [size]="20" [name]="action.icon"></lucide-icon>
                          </button>
                        }
                      }
                    }
                  </div>
                }
                }
              </article>
            }
          </div>
        }

        <div class="max-w-full overflow-x-auto" style="overflow-y: visible;" [ngClass]="{'hidden md:block': mobileCardView}">
          <table class="min-w-full">
            <thead class="border-t border-gray-100 dark:border-gray-800">
            <tr>
              @if (reorderable) {
                <th style="width: 3rem" class="border-r border-gray-200 px-2 py-3 dark:border-gray-800">
                  <span class="sr-only">Reorder</span>
                </th>
              }
              @if (selectionEnabled) {
                <th style="width: 5%" class="border-r border-gray-200 px-4 py-3 dark:border-gray-800">
                  <p class="text-theme-xs font-medium text-gray-700 dark:text-gray-400">
                    &nbsp;
                  </p>
                </th>
              }
              @for (column of visibleColumns; track column) {
                <th [ngStyle]="{'width': column.width}" class="border-r border-gray-200 px-4 py-3 dark:border-gray-800"
                    [ngClass]="{'text-center': column.align === 'center', 'text-right': column.align === 'right'}">
                  <div class="flex w-full items-center justify-between gap-2">
                    <p class="text-theme-xs font-medium text-gray-700 dark:text-gray-400 flex-1 text-left">
                      {{ column.header }}
                    </p>
                    @if (column.sortable) {
                      <button (click)="toggleSort(column)" class="shrink-0 font-medium text-gray-600 text-theme-sm dark:text-gray-400">
                        <lucide-icon size="18" [name]="sortIcon(column)"></lucide-icon>
                      </button>
                    }
                  </div>
                </th>
              }
              @if (this.rowActions.length > 0) {
                <th style="width: 5%" class="border-r border-gray-200 px-4 py-3 dark:border-gray-800">
                  <p class="text-theme-xs font-medium text-gray-700 dark:text-gray-400">
                    Action
                  </p>
                </th>
              }
            </tr>
            </thead>
            <tbody cdkDropList [cdkDropListDisabled]="!reorderable" (cdkDropListDropped)="onRowDropped($event)">
              @for (item of dataPage.data; track item.id) {
                <ng-container>
                  <tr
                    cdkDrag
                    [cdkDragDisabled]="!reorderable"
                    (click)="onRowClick(item)"
                    class="h-12 odd:bg-gray-50 even:bg-white dark:odd:bg-gray-800 dark:even:bg-gray-700 cursor-pointer transition-colors duration-200 ease-in-out"
                    [ngClass]="[
                      hover ? 'hover:bg-gray-100 dark:hover:bg-gray-600' : '',
                      highlightSelectedRow && selectedRowId === item.id ? selectedRowClass : ''
                    ]"
                    style="cursor: pointer;"
                  >
                    @if (reorderable) {
                      <td class="border-r border-gray-100 px-2 py-3 dark:border-gray-800 text-center">
                        <button
                          type="button"
                          cdkDragHandle
                          (click)="$event.stopPropagation()"
                          class="cursor-grab text-gray-400 hover:text-gray-600 active:cursor-grabbing dark:text-gray-500 dark:hover:text-gray-300"
                          title="Drag to reorder">
                          <lucide-icon [size]="18" [name]="GripIcon"></lucide-icon>
                        </button>
                      </td>
                    }
                    @if (selectionEnabled) {
                      <td class="border-r border-gray-100 px-4 py-3 dark:border-gray-800 text-center">
                        <input
                          type="checkbox"
                          class="h-4 w-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500"
                          [checked]="isSelected(item)"
                          (click)="$event.stopPropagation()"
                          (change)="onSelectionChange(item, $any($event.target).checked)"
                        >
                      </td>
                    }
                    @for (column of visibleColumns; track column) {
                      <td class="border-r border-gray-100 px-4 py-3 dark:border-gray-800"
                          [ngStyle]="{'cursor': (rowClickable || rowRouterLinkTemplate || column.clickHandler) ? 'pointer' : 'default'}"
                          [ngClass]="{'text-center': column.align === 'center', 'text-right': column.align === 'right'}"
                      >
                        <p class="text-theme-sm text-gray-700 dark:text-gray-400"
                        >
                          @if (column.type === 'image') {
                            @if (item[column.field]) {
                              <img class="max-w-40 h-12 object-contain" src="{{ item[column.field] }}" alt="{{ column.header }}">
                            }
                          } @else {
                            @if (column.component) {
                              <ng-container *ngComponentOutlet="column.component; inputs: componentInputs(column, item)"></ng-container>
                            } @else {
                              @if (column.type === 'badge' && column.getColor) {
                                <app-badge [text]="getValue(item, column)" [color]="column.getColor(item)"></app-badge>
                              } @else {
                                @if (column.type === 'boolean') {
                                  <app-badge [text]="getValue(item, column) ? 'Yes' : 'No'" [color]="getValue(item, column) ? 'success' : 'error'"></app-badge>
                                } @else {
                                  @if (column.routerLinkTemplate) {
                                    <a [routerLink]="generateRouterLink(column.routerLinkTemplate, item)" class="text-blue-500 hover:underline">
                                      {{ getValue(item, column) }}
                                    </a>
                                  } @else {
                                    @if (column.clickHandler) {
                                      <button (click)="column.clickHandler(item)" class="inline-flex items-center gap-1.5 text-sm font-normal text-brand-500 underline">
                                        {{ getValue(item, column) }}
                                        @if (column.icon && column.icon(item)) {
                                          <lucide-icon [size]="16" [name]="$any(column.icon(item))"></lucide-icon>
                                        }
                                      </button>
                                    } @else {
                                      @if (column.getColor) {
                                        <span [ngClass]="'text-' + column.getColor(item) + '-600 dark:text-' + column.getColor(item) + '-400'">
                                          {{ getValue(item, column) }}
                                        </span>
                                      } @else {
                                        {{ getValue(item, column) }}
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        </p>
                      </td>
                    }
                    @if (this.rowActions.length > 0) {
                      <td style="width: 5%" class="px-4 py-3">
                        <div class="flex w-full justify-center items-center gap-2">
                          @for (action of rowActions; track action) {
                            @if (!action.condition || action.condition(item)) {
                              @if (action.callback) {
                                <button (click)="$event.stopPropagation(); action.callback(item)"
                                        [ngClass]="action.classes ?? 'text-gray-500 hover:text-success-500 dark:text-gray-400 dark:hover:text-success-500'"
                                        [disabled]="action.disabled ? action.disabled(item) : false"
                                        [title]="action.title ? action.title(item) : ''"
                                >
                                  <lucide-icon [size]="20" [name]="action.icon"></lucide-icon>
                                </button>
                              } @else if (action.routerLink) {
                                <button (click)="$event.stopPropagation()" [routerLink]="action.routerLink(item)"
                                        class="text-gray-500 hover:text-success-500 dark:text-gray-400 dark:hover:text-success-500"
                                        [ngClass]="action.classes ?? 'text-gray-500 hover:text-success-500 dark:text-gray-400 dark:hover:text-success-500'"
                                        [disabled]="action.disabled ? action.disabled(item) : false"
                                        [title]="action.title ? action.title(item) : ''"
                                >
                                  <lucide-icon [size]="20" [name]="action.icon"></lucide-icon>
                                </button>
                              }
                            }
                          }
                        </div>
                      </td>
                    }
                  </tr>
                  @if (expandedRowTemplate && isExpanded(item)) {
                    <tr class="bg-gray-50/70 dark:bg-gray-900/40">
                      <td [attr.colspan]="expandedColspan()" class="px-4 py-4">
                        <ng-container *ngTemplateOutlet="expandedRowTemplate; context: {$implicit: item}"></ng-container>
                      </td>
                    </tr>
                  }
                </ng-container>
              }
            </tbody>
          </table>
        </div>
      }

      @if (noDataPlaceholder && dataPage && dataPage.data && dataPage.data.length === 0 && !loading) {
        <div class="flex flex-col items-center justify-center min-h-[60vh]">
          <lucide-icon [name]="EmptyIcon" size="64" class="text-gray-300 dark:text-gray-600"></lucide-icon>
          <p class="mt-4 text-lg font-medium text-gray-600 dark:text-gray-400">Nothing here yet.</p>
          <p class="mt-1 text-sm text-gray-500 dark:text-gray-500">Try adjusting filters or add a new item to get started.</p>
        </div>
      }

      @if (loading || !dataPage) {
        <div class="flex flex-col items-center justify-center min-h-[60vh]">
          <lucide-icon [name]="LoaderIcon" size="64" class="text-gray-400 dark:text-gray-600 animate-spin"></lucide-icon>
          <p class="mt-4 text-lg font-medium text-gray-500 dark:text-gray-400">Loading...</p>
        </div>
      }

      <!-- Pagination Controls -->
      @if (paginate && dataPage) {
        <div id="pagination" class="overflow-visible border-t border-gray-100 px-0 py-4 dark:border-gray-800 sm:pl-[18px] sm:pr-4">
          <div class="flex flex-col items-center gap-3 xl:flex-row xl:justify-between">
            @if (paginate) {
              <div class="hidden items-center gap-3 sm:flex">
                <span class="text-gray-500 dark:text-gray-400"> Show </span>
                <div class="w-20">
                  <app-select [height]="'9'" [control]="showPerPageControl" [choices]="perPageChoices" [clearable]="false"></app-select>
                </div>
                <span class="text-gray-500 dark:text-gray-400"> entries </span>
              </div>
            } @else {
              <div></div>
            }
            <p class="w-full max-w-full break-words text-center text-sm font-medium text-gray-500 dark:text-gray-400 xl:w-auto xl:text-left">
              Showing
              {{ startEntry }}
              to
              {{ endEntry }}
              of
              {{ totalEntries }}
              entries
            </p>
            @if (dataPage.meta.last_page > 1) {
              <div class="flex max-w-full items-center justify-center gap-0.5 overflow-x-auto pt-1 xl:justify-end xl:pt-0">
                <button (click)="prevPage()"
                        class="mr-1 flex items-center justify-center rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 shadow-theme-xs hover:bg-gray-50 disabled:opacity-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] sm:mr-2.5 sm:px-3.5 sm:py-2.5"
                        [disabled]="currentPage === 1">
                  Previous
                </button>

                <button (click)="goToPage(1)" [ngClass]="currentPage === 1 ? 'bg-blue-500/[0.08] text-brand-500' : 'text-gray-700 dark:text-gray-400'"
                        class="hidden h-10 w-10 items-center justify-center rounded-lg text-sm font-medium hover:bg-blue-500/[0.08] hover:text-brand-500 dark:hover:text-brand-500 sm:flex">
                  1
                </button>

                @if (currentPage > 3) {
                  <span class="hidden h-10 w-10 items-center justify-center rounded-lg hover:bg-blue-500/[0.08] hover:text-brand-500 dark:hover:text-brand-500 sm:flex">...</span>
                }

                @for (page of pagesAroundCurrent; track page) {
                  <button (click)="goToPage(page)" [ngClass]="currentPage === page ? 'bg-blue-500/[0.08] text-brand-500' : 'text-gray-700 dark:text-gray-400'"
                          class="hidden h-10 w-10 items-center justify-center rounded-lg text-sm font-medium hover:bg-blue-500/[0.08] hover:text-brand-500 dark:hover:text-brand-500 sm:flex">
                    {{ page }}
                  </button>
                }

                @if (currentPage < totalPages - 2) {
                  <span
                    class="hidden h-10 w-10 items-center justify-center rounded-lg text-sm font-medium text-gray-700 hover:bg-blue-500/[0.08] hover:text-brand-500 dark:text-gray-400 dark:hover:text-brand-500 sm:flex">...</span>
                }

                @if (totalPages > 1) {
                  <button (click)="goToPage(totalPages)" [ngClass]="currentPage === totalPages ? 'bg-blue-500/[0.08] text-brand-500' : 'text-gray-700 dark:text-gray-400'"
                          class="hidden h-10 w-10 items-center justify-center rounded-lg text-sm font-medium hover:bg-blue-500/[0.08] hover:text-brand-500 dark:hover:text-brand-500 sm:flex">
                    {{ totalPages }}
                  </button>
                }

                <button (click)="nextPage()"
                        class="ml-1 flex items-center justify-center rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 shadow-theme-xs hover:bg-gray-50 disabled:opacity-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] sm:ml-2.5 sm:px-3.5 sm:py-2.5"
                        [disabled]="currentPage === totalPages">
                  Next
                </button>
              </div>
            }
          </div>
        </div>
      }

      <div
        class="mb-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between"
        [ngClass]="flatShell ? 'px-0' : mobileFlatShell && mobileCardView ? 'px-0 md:px-4' : 'px-4'">
        <ng-content select="[footer]"></ng-content>
      </div>
    </div>

  </div>
</div>
